import { createFileRoute } from "@tanstack/react-router";
import { DonatePage } from "../pages/DonatePage";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { buildCompleteHead } from "../utils/seo";
import { LangProvider } from "../contexts/LangContext";

export const Route = createFileRoute("/donate")({
  head: () => {
    const seoData = buildCompleteHead(
      "default",
      "home",
      "https://lotin.uz/donate",
      "/donate",
      "/donate",
    );
    return {
      meta: [{ title: "Homiylik — Lotin.uz" }, ...seoData.meta],
      links: seoData.links,
      htmlProps: { lang: "uz-Latn" },
    };
  },
  component: Donate,
});

function Donate() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
    document.title = "Homiylik — Lotin.uz";
  }, [i18n]);

  return (
    <LangProvider lang={"uz-Latn"}>
      <DonatePage lang="uz-Latn" />
    </LangProvider>
  );
}
